require('juggler-js/dist/juggler.min.js');

export default function () {
    window.Juggler.init();
}
